import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';

export default function Page21({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<RoundScreen
				title='Exercise 07 Bench'
				rounds={[
					[
						{
							header: 'Exercise',
							value: 'Close - Grip Bench',
						},
						{
							header: '# of sets',
							value: '1 - 2',
						},
						{
							header: 'REPS / Weight',
							value: '6 - 10 Mild - Heavy',
						},
						{
							header: 'MINDSET/ FOCUSES INSTRUCTIONS',
							value: 'Working Set, Controlled Set',
						},
					],
					[
						{
							header: 'Exercise',
							value: 'Close - Grip Bench',
						},
						{
							header: '# of sets',
							value: '3',
						},
						{
							header: 'REPS / Weight',
							value: 'Mild - Heavy',
						},
						{
							header: 'MINDSET/ FOCUSES INSTRUCTIONS',
							value: 'Full On Set Till Failure',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
